import { FaArrowRight, FaFigma } from "react-icons/fa";
import productOne from "../../assets/product-one.svg";
import { SiFramer, SiNotion } from "react-icons/si";

const PortfolioSection = () => {
  return (
    <section className="bg-[#F3F3F3] px-6 py-14 md:px-10 lg:px-12">
      <div className="mx-auto max-w-[1200px]">
        <div className="flex items-end justify-between gap-8">
          <div>
            <h2 className="text-[28px] font-bold leading-tight tracking-[-0.8px] text-[#202124] md:text-[32px]">
              Build a Hireable Portfolio
            </h2>

            <p className="mt-2 max-w-[520px] text-[11px] leading-[1.6] text-[#73757D] md:text-[12px]">
              Apply your skills to real-world scenarios. Graduate with three
              comprehensive case studies.
            </p>
          </div>

          <button
            className="
              mb-1
              hidden
              items-center
              gap-1.5
              whitespace-nowrap
              text-[10px]
              font-medium
              text-[#5756D9]
              transition
              hover:gap-2
              md:flex
            "
          >
            View All Projects
            <FaArrowRight size={9} />
          </button>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl bg-white shadow-[0_2px_8px_rgba(0,0,0,0.03)]">
          <div className="px-7 py-7 md:px-8 md:py-8">
            <div
              className="
                inline-flex
                items-center
                gap-1
                rounded-full
                border
                border-[#E8E8EC]
                bg-[#FAFAFA]
                px-2
                py-1
                text-[7px]
                font-medium
                tracking-[0.3px]
                text-[#62646B]
              "
            >
              <span className="h-1.5 w-1.5 rounded-full bg-[#5756D9]" />
              CAPSTONE PROJECTS
            </div>

            {/* Title */}
            <h3
              className="
                mt-4
                max-w-[450px]
                text-[21px]
                font-bold
                leading-[1.15]
                tracking-[-0.5px]
                text-[#202124]
                md:text-[23px]
              "
            >
              Fintech App, E-commerce,
              <br />& SaaS Dashboard
            </h3>
          </div>

          <div className="h-[250px] overflow-hidden bg-[#E7EBED] md:h-[300px]">
            <img
              src={productOne}
              alt="Fintech app, ecommerce and SaaS dashboard projects"
              className="
                h-full
                w-full
                object-cover
                object-center
              "
            />
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-[1200px] border-t border-[#E4E4E4] pt-8">
        <div className="text-center">
          <p
            className="
              text-[8px]
              font-medium
              tracking-[0.8px]
              text-[#73757D]
            "
          >
            MASTER THE INDUSTRY STANDARD TOOLS
          </p>

          {/* Tools */}
          <div className="mt-5 flex items-center justify-center gap-7 md:gap-9">
            {/* Figma */}
            <div className="flex items-center gap-2 text-[#85868E]">
              <FaFigma size={19} />
              <span className="text-[15px] font-medium">Figma</span>
            </div>

            {/* Framer */}
            <div className="flex items-center gap-2 text-[#85868E]">
              <SiFramer size={17} />
              <span className="text-[15px] font-medium">Framer</span>
            </div>

            {/* Notion */}
            <div className="flex items-center gap-2 text-[#85868E]">
              <SiNotion size={18} />
              <span className="text-[15px] font-medium">Notion</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
